// extracted by mini-css-extract-plugin
export default {"wrapper":"indicator_wrapper__uabgq","icon":"indicator_icon__T9l6S","text":"indicator_text__x4GD5","messageGroup":"indicator_messageGroup__x2aPs"};